import { useStatsigClient } from "@statsig/react-bindings";

/**
 * Custom hook to check if Google Ads integration is enabled.
 *
 * Returns a boolean indicating whether the "enable_frontend_google_ads_integration_milestone_1"
 * feature gate is enabled on Statsig.
 */
export const useEnableGoogleAdsIntegrationMilestone1 = (): boolean => {
  const statsigClient = useStatsigClient();
  const enableGoogleAdsIntegration = statsigClient.checkGate(
    "enable_frontend_google_ads_integration_milestone_1",
  );

  return enableGoogleAdsIntegration;
};

/**
 * Custom hook to check if Google Ads integration milestone 2 is enabled.
 *
 * Returns a boolean indicating whether the "enable_frontend_google_ads_integration_milestone_2"
 * feature gate is enabled on Statsig.
 */
export const useEnableGoogleAdsIntegrationMilestone2 = (): boolean => {
  const statsigClient = useStatsigClient();
  const enableGoogleAdsIntegration = statsigClient.checkGate(
    "enable_frontend_google_ads_integration_milestone_2",
  );

  return enableGoogleAdsIntegration;
};

/**
 * Custom hook to check if Google Ads integration milestone 3 is enabled.
 *
 * Returns a boolean indicating whether the "enable_frontend_google_ads_integration_milestone_3"
 * feature gate is enabled on Statsig.
 */
export const useEnableGoogleAdsIntegrationMilestone3 = (): boolean => {
  const statsigClient = useStatsigClient();
  const enableGoogleAdsIntegration = statsigClient.checkGate(
    "enable_frontend_google_ads_integration_milestone_3",
  );

  return enableGoogleAdsIntegration;
};

/**
 * Hook gating the Conversions tab on the Statsig
 * `enable_frontend_google_ads_conversion` flag.
 */
export const useEnableGoogleAdsConversionMapping = (): boolean => {
  const statsigClient = useStatsigClient();
  return statsigClient.checkGate("enable_frontend_google_ads_conversion");
};
